import { render, staticRenderFns } from "./01Game.vue?vue&type=template&id=24b3c1f9&"
import script from "./01Game.vue?vue&type=script&lang=js&"
export * from "./01Game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports